import { SuppliesSubscriptionOrderInterval } from "@redotech/cockroachdb-codegen/tables/product/supplies-subscription-order-interval";
import { SuppliesSubscriptionStatus } from "@redotech/cockroachdb-codegen/tables/product/supplies-subscription-status";
import { suppliesSubscriptionIdFormat } from "@redotech/redo-marketplace-id";
import { SortDirection } from "@redotech/redo-views-common/table";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const SuppliesSubscriptionRowSchema_ = z.object({
  id: suppliesSubscriptionIdFormat.schema,
  productTitle: z.string(),
  productSku: z.string().nullable(),
  productImageUrl: z.string().nullable(),
  quantity: z.number(),
  orderInterval: z.enum(SuppliesSubscriptionOrderInterval),
  orderIntervalFrequency: z.number(),
  // Next scheduled order date.
  nextReorderDate: zExt.plainDate(),
  // Resolved display name of the delivery destination.
  destination: z.string(),
  status: z.enum(SuppliesSubscriptionStatus),
  // Timestamp of the most recent placed order; null if none yet.
  lastOrderDate: z.date().nullable(),
});

export const SuppliesSubscriptionRowSchema: z.ZodType<SuppliesSubscriptionRow> =
  SuppliesSubscriptionRowSchema_;
export interface SuppliesSubscriptionRow extends z.infer<
  typeof SuppliesSubscriptionRowSchema_
> {}

export const getSuppliesSubscriptions = {
  name: "getSuppliesSubscriptions" as const,
  input: z.object({
    pageNumber: z.number(),
    pageSize: z.number(),
    sort: z
      .object({ key: z.string(), direction: createEnum(SortDirection) })
      .nullish(),
  }),
  output: z.object({ subscriptions: z.array(SuppliesSubscriptionRowSchema) }),
};

export const getSuppliesSubscriptionsCount = {
  name: "getSuppliesSubscriptionsCount" as const,
  input: z.object({}),
  output: z.object({ total: z.number() }),
};
